import React from 'react'
import injectSheet from 'react-jss/lib/injectSheet'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlay } from '@fortawesome/pro-solid-svg-icons/faPlay'

const videoThumbnailStyles = {
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& > img': {
      position: 'absolute',
      left: '0',
      top: '0',
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      zIndex: '5'
    }
  },
  playIcon: {
    position: 'relative',
    zIndex: '10',
    fontSize: '2em',
    width: '2.5em',
    height: '2.5em',
    background: 'rgba(0, 0, 0, 0.6)',
    borderRadius: '100%',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: '.2em'
  }
}

const VideoSlideThumbnail = injectSheet(videoThumbnailStyles)(
  ({ classes, slide, onLoad }) => {
    return (
      <div className={classes.container}>
        <img
          onLoad={onLoad}
          src={`https://img.youtube.com/vi/${slide.video.id}/sddefault.jpg`}
          alt="youtube thumbnail"
        />
        <div className={classes.playIcon}>
          <FontAwesomeIcon icon={faPlay} />
        </div>
      </div>
    )
  }
)

export default VideoSlideThumbnail
